import {
  withProps,
  compose,
  branch,
  renderComponent,
  withHandlers,
  withState,
  lifecycle,
} from 'recompose';
import { connect } from 'react-redux';
import { get, once } from 'lodash';
import PaymentForm from '../components/PaymentFormStripe';
import WithToggle from '../../hoc/WithToggle';
import PaymentFormApplePay from '../components/PaymentFormApplePay';
import { applePaySession } from '../../utils/applePay';
import withRouteParameters from './withRouteParameters';
import { getShopCountry, getShopCurrency } from '../../shops/selectors';
import withStripeInput from './withStripeInput';
import Stripe from '../../utils/stripe';
import { getAppointmentId, getIsValidatingAppointment } from '../selectors';
import analytics
  from '../../applicationServices/analytics/BookingAnalytics';

const mapStateToProps = (state, props) => {
  const areWeOnChargeAppointment = getAppointmentId(state);
  const hasApplePay = state.app.applePay && !props.disableApplePay;
  return {
    hasApplePay,
    currency: getShopCurrency(state, props.shopRoute),
    shopCountry: getShopCountry(state, props.shopRoute),
    areWeOnChargeAppointment: getAppointmentId(state),
    initialState: hasApplePay && areWeOnChargeAppointment,
    isValidating: getIsValidatingAppointment(state),
  };
};

const showSwalError = (error) => {
  window.swal({
    title: 'Error',
    text: get(error, 'message', ''),
    type: 'error',
    confirmButtonColor: '#dd6b55',
  });
};

export default compose(
  withRouteParameters,
  connect(mapStateToProps),
  WithToggle,
  withState('processing', 'setProcessing', false),
  withProps(props => ({
    toggleApplePay: props.toggle,
    formDisabled: props.formDisabled || props.processing || props.isValidating,
  })),
  withHandlers({
    handleProcessingError: props => (error) => {
      props.setProcessing(false);
      showSwalError(error);
    },
  }),
  withHandlers({
    onClick: props => () => {
      props.setProcessing(true);
      applePaySession(
        props.amount,
        props.currency,
        async (result) => {
          analytics.fillCardInfo({ source: 'squire_modal', isApplePay: true });
          const setupResponse = await props.confirmSetup(result.token);
          props.setProcessing(false);
          return setupResponse;
        },
        props.handleProcessingError,
        () => props.setProcessing(false),
      );
    },
  }),
  branch(props => props.toggled, renderComponent(PaymentFormApplePay)),
  withStripeInput({}),
  withState('zipCode', 'setZipCode', ''),
  withState('submitEnabled', 'setSubmitEnabled', false),
  withHandlers({
    submit: props => async (e) => {
      e.preventDefault();

      props.setProcessing(true);
      let token = null;

      if (!(props.isCoveredByDiscount)) {
        const stripe = new Stripe();
        props.setStripeInputsDisabled(true);

        const { error, ...result } = await stripe.createToken(
          props.cardNumber,
          {
            address_zip: props.zipCode,
          },
        );

        token = result.token;
        props.setStripeInputsDisabled(false);

        const isZipValid = props.validateZipCode();
        if (error || !isZipValid) {
          if (isZipValid && error.type !== 'validation_error') {
            props.handleProcessingError(error);
          }

          props.setProcessing(false);
          return;
        }
      }
      try {
        await props.confirmSetup(token);
      } catch (error) {
        props.handleProcessingError(error);
      } finally {
        props.setProcessing(false);
      }
    },
    setZipCode: props => (event) => {
      props.setZipCode(event.target.value);
      props.validateZipCode();
    },
    zipCodeBlur: props => () => {
      if (!props.hasErrors) {
        if (props.zipCode) {
          analytics.fillCardInfoField('cardZipCode');
        }
        analytics.fillCardInfo({ source: 'squire_modal' });
      }
    },
    mountStripeInputs: props => once(() => props.mountStripeInputs()),
  }),
  lifecycle({
    componentDidUpdate(prevProps) {
      if (this.props.cardNumber) {
        if (prevProps.isCoveredByDiscount !== this.props.isCoveredByDiscount) {
          this.props.setStripeInputsDisabled(this.props.isCoveredByDiscount);
        }
      }

      if (
        this.props.cardNumber !== '' &&
        this.props.cardExpiry !== '' &&
        this.props.cardCvc !== '' &&
        this.props.zipCode !== '' &&
        this.props.submitEnabled === false
      ) {
        this.props.setSubmitEnabled(true);
      }
    },
    componentDidMount() {
      this.props.mountStripeInputs();
      setTimeout(() => this.props.focusInput('cardNumber'), 1000);
    },
    componentWillUnmount() {
      this.props.unmountStripeInputs();
    },
  }),
)(PaymentForm);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/PaymentFormContainerStripe.jsx